import { Box } from "@mui/material";

import type { AssistantInfo } from "./assistants";
import type { FC } from "react";

export const AssistantLogo: FC<{ assistant: AssistantInfo; size: number }> = ({
  assistant,
  size,
}) => (
  <Box
    component="img"
    src={assistant.logo}
    alt=""
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      borderRadius: `${size / 4}px`,
      boxSizing: "border-box",
      ...(assistant.id === "chatgpt" ? { border: 1, borderColor: "divider" } : null),
    }}
  />
);
